import React, { useState } from "react";
import {
  Drawer,
  Avatar,
  Space,
  Typography,
  Input,
  Button,
  Divider,
} from "antd";
import { SmileOutlined, SendOutlined } from "@ant-design/icons";

const { Text } = Typography;

const messagesMock = [
  {
    id: 1,
    user: "Elisa William",
    time: "45 mins ago",
    avatar: "https://randomuser.me/api/portraits/women/44.jpg",
    message: "Wishing you only the best in your upcoming journey",
  },
  {
    id: 2,
    user: "Elisa William",
    time: "45 mins ago",
    avatar: "https://randomuser.me/api/portraits/women/44.jpg",
    message: "Have a fantastic year ahead 🎉",
  },
];

export default function CommentDrawer({ open, onClose, user }) {
  const [comment, setComment] = useState("");

  return (
    <Drawer
      title="Messages"
      placement="right"
      width={window.innerWidth < 768 ? "100%" : 420}
      open={open}
      onClose={onClose}
    >
      <Space direction="vertical" style={{ width: "100%" }}>
        {messagesMock.map((msg) => (
          <div key={msg.id}>
            <Space align="start">
              <Avatar src={msg.avatar} />
              <div>
                <Text strong>{msg.user}</Text>{" "}
                <Text type="secondary">{msg.time}</Text>
                <div style={{ marginTop: 4 }}>{msg.message}</div>
                <Space size="small" style={{ marginTop: 6 }}>
                  <SmileOutlined />
                  <Text type="primary" style={{ cursor: "pointer" }}>
                    Reply
                  </Text>
                </Space>
              </div>
            </Space>
            <Divider />
          </div>
        ))}
      </Space>

      {/* Input */}
      <div
        style={{
          position: "sticky",
          bottom: 0,
          background: "#fff",
          paddingTop: 10,
        }}
      >
        <Input
          placeholder="Type here..."
          value={comment}
          onChange={(e) => setComment(e.target.value)}
          suffix={
            <Button type="primary" shape="circle" icon={<SendOutlined />} />
          }
        />
      </div>
    </Drawer>
  );
}
